import React from 'react';
import {
  Box,
  Container,
  Paper,
  Stack,
  Typography
} from '@mui/material';

const policySections = [
  {
    heading: 'Information We Collect',
    items: [
      'Personal Information: When you visit our website, place an order, or communicate with us, we may collect details such as your name, email address, shipping address, billing address, phone number, and payment information.',
      'Usage Information: We also gather non-personal browsing data, including IP address, browser type, operating system, and pages visited.'
    ]
  },
  {
    heading: 'How We Use Your Information',
    items: [
      'We process personal information to fulfil orders, support customers, and respond to enquiries.',
      'Where permitted by law, we use your information to improve our site, personalise experiences, and send marketing communications about our products and promotions.'
    ]
  },
  {
    heading: 'Information Sharing and Disclosure',
    items: [
      'Your information may be shared with trusted service providers who assist with website operations, payment processing, logistics, and similar services.',
      'We may disclose information to comply with legal obligations, protect our rights or property, or prevent fraud and illegal activities.'
    ]
  },
  {
    heading: 'Data Security',
    items: [
      'We employ reasonable safeguards to maintain the security and accuracy of your personal information. However, no method of transmission over the internet or electronic storage is completely secure.'
    ]
  },
  {
    heading: 'Your Choices',
    items: [
      'You may access, update, or request deletion of your personal information by contacting us using the details below.',
      'To opt out of marketing emails, follow the unsubscribe instructions contained in our communications or contact us directly.'
    ]
  },
  {
    heading: "Children's Privacy",
    items: [
      'Our website is not intended for children under the age of 13, and we do not knowingly collect personal information from children.'
    ]
  },
  {
    heading: 'Changes to This Policy',
    items: [
      'We may update this Privacy Policy periodically to reflect changes in our practices or applicable laws. Material updates will be posted on this page.'
    ]
  },
  {
    heading: 'Contact Us',
    items: [
      'If you have questions or concerns about this Privacy Policy or our data practices, please contact us at info@zaror.co.uk.'
    ]
  }
];

const PrivacyPolicy = () => {
  return (
    <Box>
      <Box sx={{ backgroundColor: '#0f172a', color: 'white', py: { xs: 10, md: 12 } }}>
        <Container maxWidth="lg">
          <Stack spacing={2} alignItems={{ xs: 'center', md: 'flex-start' }}>
            <Typography variant="h4" sx={{ letterSpacing: 6, textTransform: 'uppercase' }}>
              Privacy Policy
            </Typography>
            <Typography
              variant="h2"
              component="h1"
              sx={{ fontWeight: 700, textAlign: { xs: 'center', md: 'left' } }}
            >
              Your privacy matters to us
            </Typography>
            <Typography
              variant="h6"
              sx={{
                maxWidth: 720,
                opacity: 0.85,
                textAlign: { xs: 'center', md: 'left' }
              }}
            >
              Zaror Sports is committed to protecting the privacy and security of your personal information. This policy outlines how information is collected, used, and safeguarded when you interact with us.
            </Typography>
          </Stack>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Stack spacing={4}>
          {policySections.map((section) => (
            <Paper key={section.heading} elevation={2} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3 }}>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                {section.heading}
              </Typography>
              <Stack spacing={1.5}>
                {section.items.map((item, index) => (
                  <Typography key={index} variant="body1" color="text.secondary">
                    {item}
                  </Typography>
                ))}
              </Stack>
            </Paper>
          ))}
        </Stack>
      </Container>

      <Box sx={{ py: 4, textAlign: 'center', bgcolor: 'background.default' }}>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} All Rights Reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;
